





































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { actionsEvent } from '@/setup';
import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchOrdenSerTec } from './fetchOrdenSerTec';
//import modalCREARDetalleAltaServicio from '@/pantallas/Conecta/AltasServicio/modal_crear_detalle_alta.vue';
import TablaSeriesTodos from './TablaSeriesTodos.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import config from '@/config/index';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    MantenedorGrid,
    DatePicker,
    TablaSeriesTodos,
    MantenedorGridSinCodigo,
    'app-confirmacion': Confirmation,
  },
})
export default class modalVerDetalleSerTec extends Vue {
  readonly funcionalidad: Funcionalidades = Funcionalidades.OrdenesSerTec;
  @Prop({ default: true }) show: boolean;
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: null }) id_alta_serv: any;
  @Prop({ default: null }) numero_orden: any;
  @Prop({ default: null }) filtro_tecnico: any;
  @Prop({ default: null }) tabs: any;
  @Prop({ default: null }) model_altasernumero: any;
  @Prop({ default: null }) model_fecha_instalacion: any;
  @Prop({ default: null }) model_altaserorden_numero: any;
  @Prop({ default: null }) model_patente_vehiculo: any;
  @Prop({ default: null }) model_codigo_vehiculo: any;
  @Prop({ default: null }) model_descripcion_vehiculo: any;
  @Prop({ default: null }) model_cliente: any;
  @Prop({ default: null }) model_filtro_coordinador: any;
  @Prop({ default: null }) filtro_cliente: any;
  @Prop({ default: null }) filtro_coordinador: any;
  @Prop({ default: null }) model_flota: any;
  @Prop({ default: null }) filtro_flota: any;
  @Prop({ default: null }) filtro_vehiculos_cliente: any;
  @Prop({ default: null }) filtro_flotas_cliente: any;
  @Prop({ default: null }) model_vehiculos_cliente: any;
  @Prop({ default: null }) model_flota_cliente: any;
  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) disabled_flota: boolean = true;
  @Prop({ default: null }) disabled_vehiculo: boolean = true;
  @Prop({ default: 0 }) CANTIDAD_DETALLE_INICIAL: Number;
  @Prop({ default: [] }) LISTAaltasservicioDETALLE: any;
  @Prop({ default: null }) filtro_anulado: any = null;
  @Prop({ default: null }) model_filtro_anulado: any;
  @Prop({ default: true }) disabled_cliente: boolean = true;
  @Prop({ default: true }) disabled_coordinador: boolean = true;
  @Prop({ default: true }) disabled_fecha_instalacion: boolean = true;
  @Prop({ default: true }) disabled_tecnico: boolean = true;
  @Prop({ default: true }) disabled_numero_orden: boolean = true;
  @Prop({ default: true }) disabled_anulada: boolean = true;
  @Prop({ default: true }) btnCrear_disabled: boolean = false;
  @Prop({ default: null }) ITEM: any; //obtiene los valores del confirm del eliminar fila en el detalla
  @Prop({ default: null }) ALTA: any; //obtiene los valores del confirm del eliminar fila en el detalla
  @Prop({ default: null }) model_marca_vehiculo: any;
  @Prop({ default: null }) filtro_marcas_vehiculo: any;
  @Prop({ default: null }) model_modelo_vehiculo: any;
  @Prop({ default: null }) model_year_vehiculo: any;
  @Prop({ default: null }) filtro_modelos_vehiculo: any;
  @Prop({ default: true }) disabled_marca_vehiculo: boolean = true;
  @Prop({ default: true }) disabled_modelo_vehiculo: boolean = true;
  @Prop({ default: true }) disabled_year_vehiculo: boolean = true;
  @Prop({ default: true }) data!: any;

  detalle_alta_tecnico: any = [];
  gridApi: GridApi = null;
  gridApi2: GridApi = null;
  columnApi2: ColumnApi = null;
  gridEvent2: GridReadyEvent = null;
  columnDef: ColDef[] = [];
  gridOptions3: GridOptions = null;

  dataList: any = null;

  model_filtro_tecnico: any = null;
  mostrarModalCONFIRMAR: boolean = false;
  Modal_confirmar_TEXTO: any = '';
  modal_tabla: any;
  dictionaryFormErrors: any = {};
  naranja: boolean = false;

  beforeMount() {
    this.loadingService.showLoading(undefined, 'GLOBAL');
  }

  get fechaMaximaInicio() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return moment(fechaMax) as moment.Moment;
  }

  AltaServicioDetalleModalState: boolean = false;

  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionEliminar];

  constructor() {
    super();
    actionsEvent.onEliminar(this.handlerbuttonmodalEliminar);

    this.columnDef = this.girdColumns();

    this.gridOptions3 = {
      columnDefs: this.columnDef,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady2,
    };
  }

  private girdColumns(): ColDef[] {
    const cols = [
      { field: 'Fecha de alta', id: 'movifecha_alta' },
      { field: 'Usuario', id: 'usuario' },
      { field: 'Ubicación Origen', id: 'ubicacion_origen' },
      { field: 'Número de Operación', id: 'moviopera_numero' },
      { field: 'Ubicación', id: 'tipoubicaname' },
      { field: 'Observaciones', id: 'moviobs' },
      { field: 'Caja Número', id: 'movicajanro' },
      { field: 'Número de Despacho', id: 'despanumero' },
      { field: 'Fecha Entrega', id: 'movifecha_recibe' },
      { field: 'Estado', id: 'moviestado' },
      { field: 'Tipo de Operación', id: 'moviopera_tipo' },
      { field: 'Fecha Mdificación', id: 'movifecha_modifica' },
      { field: 'Número de Serie', id: 'serienumero' },
      { field: 'Equipo', id: 'tipoeqname' },
      { field: 'Serie Rack', id: 'moviserierack' },
      { field: 'Serie Bloque', id: 'moviseriebloque' },
    ];

    return cols.map(col => ({
      headerName: col.field,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      width: 230,
      minWidth: 100,
    }));
  }

  async handleMainGridReady2(e: GridReadyEvent) {
    this.gridApi2 = e.api;
    this.columnApi2 = e.columnApi;
    this.gridEvent2 = e;
    this.dataList = await this.getSeries();
    this.gridApi2.setRowData(this.dataList);
    this.gridApi2.setDomLayout('autoHeight');
  }

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  cerrarModalDetalleAlta() {
    this.AltaServicioDetalleModalState = false;
  }

  cargarDetalleAlta(event: any) {
    if (this.LISTAaltasservicioDETALLE === undefined) {
      this.LISTAaltasservicioDETALLE = [];
    }
    this.LISTAaltasservicioDETALLE = this.LISTAaltasservicioDETALLE.concat(
      event
    );
    /*
    if (this.accion_modal == 'EDITAR') {
      this.LISTAaltasservicioDETALLE = this.LISTAaltasservicioDETALLE.concat(
        event
      );
    } else {
      this.LISTAaltasservicioDETALLE = event;
    }
    */

    //RELLENO LOS ID DE DETALLE CON UN CORRELATIVO
    if (this.LISTAaltasservicioDETALLE.length > 0) {
      for (let i = 0; i < this.LISTAaltasservicioDETALLE.length; i++) {
        if (this.LISTAaltasservicioDETALLE[i].altaserdetlinea == undefined) {
          this.LISTAaltasservicioDETALLE[i].altaserdetlinea =
            Number(this.CANTIDAD_DETALLE_INICIAL) + 1;
          this.CANTIDAD_DETALLE_INICIAL =
            Number(this.CANTIDAD_DETALLE_INICIAL) + 1;
        }
      }
    }

    this.gridApi.setRowData(this.LISTAaltasservicioDETALLE);
    this.gridApi.setDomLayout('autoHeight');
    this.AltaServicioDetalleModalState = false;
  }

  modalverDetalleCallback(event: any) {
    this.AltaServicioDetalleModalState = event;
  }

  handlerbuttonmodalEliminar(params: ICellRendererParams) {
    this.ITEM = null;
    this.ALTA = null;
    if (this.accion_modal == 'CREAR') {
      this.mostrarModalCONFIRMAR = true;
      this.ITEM = params.data.altaserdetlinea;
      this.ALTA = this.model_altasernumero; //al crear es null

      this.Modal_confirmar_TEXTO =
        '¿Está seguro que desea eliminar ítem ' +
        this.ITEM +
        ' de alta de servicio ' +
        this.ALTA +
        ' ?';
    } else {
      this.$snotify.error('Modo edición no permite modificar detalle');
    }
  }

  gridOptions2: GridOptions = {
    columnDefs: [
      {
        headerName: 'Cambio SIM',
        field: 'sim_cambio',
        width: 150,
        hide: false,
      },
      {
        headerName: 'Cambio Equipo',
        field: 'equipo_cambio',
        width: 150,
        hide: false,
      },
      {
        headerName: 'Serie',
        field: 'serie',
        width: 150,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Tipo Equipo',
        field: 'tipoeqname',
        width: 150,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Serie Saliente',
        field: 'serie_saliente',
        hide: false,
        width: 150,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Serie Entrante',
        field: 'serie_entrante',
        width: 150,
        hide: false,
      },
      {
        headerName: 'SIM',
        field: 'sim',
        width: 150,
        hide: false,
      },
      {
        headerName: 'SIM Saliente',
        field: 'sim_saliente',
        width: 150,
        hide: false,
      },
      {
        headerName: 'SIM Entrante',
        field: 'sim_entrante',
        width: 150,
        hide: false,
      },
      {
        headerName: 'Observaciones',
        field: 'observaciones',
        width: 150,
        hide: false,
      },
      {
        headerName: 'Detalle',
        field: 'detalle',
        width: 150,
        hide: false,
      },
      {
        headerName: 'Producto',
        field: 'producto',
        width: 150,
        hide: false,
      },
    ],
    pagination: true,
    paginationPageSize: 30,
    onGridReady: this.handleGridReady,
  };

  cambio_tecnico() {
    //this.modal_tabla.recargar_tecnico();
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.LISTAaltasservicioDETALLE = await this.get_alta_serviciodetalle();
    this.gridApi.setRowData(this.LISTAaltasservicioDETALLE);
    this.gridApi.setDomLayout('autoHeight');
  }

  async modal_abre_crear_detalle_alta() {
    if (this.accion_modal == 'CREAR') {
      if (this.model_filtro_tecnico == null) {
        this.$snotify.error('Sin técnico seleccionado en cabecera');
      } else {
        this.AltaServicioDetalleModalState = true;
        let a = await this.modal_tabla.recargarInformacion();
      }
    } else {
      this.$snotify.error('Modo edición no permite modificar detalle');
    }
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }

  async confirmCallback(val: boolean) {
    if (val == true) {
      this.handle_MS_Eliminar();
    } else {
      this.mostrarModalCONFIRMAR = false;
    }
  }

  async handle_MS_Eliminar() {
    //this.ALTA al crear es null
    if (this.accion_modal == 'CREAR') {
      for (let i = 0; i < this.LISTAaltasservicioDETALLE.length; i++) {
        if (this.LISTAaltasservicioDETALLE[i].altaserdetlinea == this.ITEM) {
          this.LISTAaltasservicioDETALLE.splice(i, 1);

          //recargo la grilla
          this.gridApi.setRowData(this.LISTAaltasservicioDETALLE);
          this.gridApi.setDomLayout('autoHeight');
        }
      }
    } //end if crear
    this.ITEM = null;
    this.mostrarModalCONFIRMAR = false;
  }

  async mounted() {
    this.loadingService.showLoading();
    this.modal_tabla = this.$refs.TablaSeriesTotales;

    if (this.accion_modal == 'EDITAR') {
      let lista = await this.get_listas_editar(this.id_alta_serv);
      let res = await this.get_alta_servicioCAB();
    }

    //let fil = await this.get_filters();
    if (this.accion_modal == 'CREAR') {
      let coordinadores = await this.get_listas_coordinadores();
      let marcas_vehiculos = await this.get_listas_marcas();
      let modelos_behiculos = await this.get_listas_modelos_vehiculos();
      let tecnicos = await this.get_listas_tecnicos();
      let clientes = await this.get_listas_clientes();
      let proximonumero = await this.get_estimated_altaserv_num();

      this.disabled_cliente = false;
      this.disabled_coordinador = false;
      this.disabled_fecha_instalacion = false;
      this.disabled_numero_orden = false;
      this.disabled_anulada = false;
      this.disabled_tecnico = false;
      this.disabled_marca_vehiculo = false;
      this.disabled_modelo_vehiculo = false;
      this.disabled_year_vehiculo = false;
    }
    let estados = await this.get_estados_anulacion();
    this.loadingService.hideLoading();

    /* INICIO VALIDACION PATENTES */
    this.dictionaryFormErrors = {
      custom: {
        patente: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () => 'Patente con formato diferente al ya preestablecido',
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);

    /* FIN VALIDACION PATENTES */
  }

  async get_listas_editar(numero_alta: any) {
    this.loadingService.showLoading(undefined, 'get_listas_editar');
    return fetchOrdenSerTec(
      { altasernumero: numero_alta },
      'conecta_ordenes_sertec/get_listas_editar'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_listas_editar');
        this.filtro_coordinador = data.data.COORDINADORES.LISTA;
        this.filtro_tecnico = data.data.TECNICOS.LISTA;
        this.filtro_cliente = data.data.CLIENTES.LISTA;
        this.filtro_flotas_cliente = data.data.FLOTAS.data.LISTA;
        //this.filtro_vehiculos_cliente = data.data.VEHICULOS.data.LISTA;
        //this.disabled_flota = false;
        //this.disabled_vehiculo = false;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  closeModal() {
    this.$emit('modalverDetalleEmit', false);
  }

  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  get_estimated_altaserv_num() {
    if (this.accion_modal == 'CREAR') {
      this.loadingService.showLoading(undefined, 'get_estimated_altaserv_num');
      return fetchOrdenSerTec(
        { '': '' },
        'conecta_ordenes_sertec/get_estimated_altaserv_num'
      )
        .then((data: any) => {
          this.loadingService.hideLoading('get_estimated_altaserv_num');
          this.model_altasernumero = data.data.id;
          this.loadingService.hideLoading('GLOBAL');
        })
        .catch((error: any) => {
          this.loadingService.hideLoading('GLOBAL');
          return null;
        })
        .finally(() => {
          this.loadingService.hideLoading('GLOBAL');
          return null;
        });
    }
  }

  toUpperPatente() {
    this.model_vehiculos_cliente.value = this.model_vehiculos_cliente.value.toUpperCase();
  }

  async get_alta_servicioCAB() {
    this.loadingService.showLoading(undefined, 'get_alta_servicioCAB');
    return fetchOrdenSerTec(
      { altasernumero: this.id_alta_serv },
      'conecta_ordenes_sertec/get_alta_servicio_cab'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_alta_servicioCAB');
        let cab = data.data.CABEZERA;
        this.model_altasernumero = cab.altasernumero;
        this.model_fecha_instalacion = moment(
          cab.altafecha_instala,
          'YYYY-MM-DD'
        );
        this.model_filtro_tecnico = cab.tecnicoid;
        this.model_altaserorden_numero = cab.altaserorden_numero;
        this.model_cliente = cab.clienterut;
        this.model_flota_cliente = cab.cod_flota;
        this.model_filtro_coordinador = cab.coorid;
        this.model_vehiculos_cliente = cab.vehiculoid;
        this.model_filtro_anulado = cab.Anulado;
        this.model_marca_vehiculo = cab.altaser_marca_vehiculo;
        this.model_modelo_vehiculo = cab.altaser_modelo_vehiculo;
        this.model_year_vehiculo = cab.altaser_anio_vehiculo;
        if (cab.Anulado == 'False') {
          this.disabled_anulada = false;
        }
        //this.disabled_flota = false;
        //this.disabled_vehiculo = false;
        return cab;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_alta_serviciodetalle() {
    if (this.accion_modal == 'EDITAR') {
      this.loadingService.showLoading(
        undefined,
        'get_grid_data_altas_servicio'
      );
      return fetchOrdenSerTec(
        { altasernumero: this.id_alta_serv },
        'conecta_ordenes_sertec/get_altaservicio_detalle'
      )
        .then((data: any) => {
          this.loadingService.hideLoading('get_grid_data_altas_servicio');

          let detalle = data.data.DETALLE.LISTA;
          this.CANTIDAD_DETALLE_INICIAL = data.data.CANTIDAD_DETALLE;
          return detalle;
        })
        .catch((error: any) => {
          return null;
        })
        .finally(() => {
          return null;
        });
    }
  }

  async get_listas_por_cliente() {
    //this.filtro_vehiculos_cliente = null;
    //this.disabled_flota = true;
    //this.disabled_vehiculo = true;
    this.loadingService.showLoading(undefined, 'get_vehiculos_por_cliente');
    return fetchOrdenSerTec(
      { rut_cliente: this.model_cliente, id_flota: this.model_flota_cliente },
      'conecta_ordenes_sertec/get_listas_por_cliente_ms'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_vehiculos_por_cliente');

        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
          this.disabled_flota = true;
          this.disabled_vehiculo = true;
        } else {
          this.disabled_flota = false;
          this.disabled_vehiculo = false;
          //this.filtro_vehiculos_cliente = data.data.VEHICULOS.LISTA;
          this.filtro_flotas_cliente = data.data.FLOTAS.LISTA;
          this.filtro_coordinador = data.data.COORDINADORES.LISTA;
          this.filtro_tecnico = data.data.TECNICOS.LISTA;
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_listas_tecnicos() {
    this.loadingService.showLoading(undefined, 'get_listas_tecnicos');
    return fetchOrdenSerTec({}, 'conecta_ordenes_sertec/get_tecnicos')
      .then((data: any) => {
        this.loadingService.hideLoading('get_listas_tecnicos');
        this.filtro_tecnico = data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_listas_marcas() {
    this.loadingService.showLoading(undefined, 'get_marcas_vehiculos');
    return fetchOrdenSerTec({}, 'conecta_ordenes_sertec/get_marcas_vehiculos')
      .then((data: any) => {
        this.loadingService.hideLoading('get_marcas_vehiculos');
        this.filtro_marcas_vehiculo = data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_listas_modelos_vehiculos() {
    this.loadingService.showLoading(undefined, 'get_modelos_vehiculos');
    return fetchOrdenSerTec({}, 'conecta_ordenes_sertec/get_modelos_vehiculos')
      .then((data: any) => {
        this.loadingService.hideLoading('get_modelos_vehiculos');
        this.filtro_modelos_vehiculo = data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_listas_clientes() {
    this.loadingService.showLoading(undefined, 'get_listas_clientes');
    return fetchOrdenSerTec({}, 'conecta_ordenes_sertec/get_clientes')
      .then((data: any) => {
        this.loadingService.hideLoading('get_listas_clientes');
        this.filtro_cliente = data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_listas_coordinadores() {
    this.loadingService.showLoading(undefined, 'get_listas_coordinadores');
    return fetchOrdenSerTec({}, 'conecta_ordenes_sertec/get_coordinadores')
      .then((data: any) => {
        this.loadingService.hideLoading('get_listas_coordinadores');
        this.filtro_coordinador = data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_estados_anulacion() {
    if (this.accion_modal == 'EDITAR') {
      this.loadingService.showLoading(undefined, 'get_estados_anulacion');
      return fetchOrdenSerTec(
        {},
        'conecta_ordenes_sertec/get_estados_anulacion'
      )
        .then((data: any) => {
          this.loadingService.hideLoading('get_estados_anulacion');
          this.filtro_anulado = data.data.TIPO_ANULACIONES;
        })
        .catch((error: any) => {
          return null;
        })
        .finally(() => {
          return null;
        });
    }
  }

  async busca_flota_vehiculo() {
    this.loadingService.showLoading(undefined, 'busca_flota_vehiculo');
    return fetchOrdenSerTec(
      { id_vehiculo: this.model_vehiculos_cliente },
      'conecta_ordenes_sertec/busca_flota_vehiculo'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('busca_flota_vehiculo');
        //this.filtro_flotas_cliente=data.data.LISTA;
        this.model_flota_cliente = data.data.LISTA[0].cod_flota;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  crear() {
    if (this.validar() == true) {
      this.btnCrear_disabled = true;
      this.loadingService.showLoading(undefined, 'crear_alta_servicio');
      return fetchOrdenSerTec(
        {
          altasernumero: this.model_altasernumero,
          cliente: this.model_cliente,
          flota: this.model_flota_cliente,
          vehiculo: this.model_vehiculos_cliente,
          coordinador: this.model_filtro_coordinador,
          fecha_instalacion: this.model_fecha_instalacion,
          tecnico: this.model_filtro_tecnico,
          orden_numero: this.model_altaserorden_numero,
          marca_vehiculo: this.model_marca_vehiculo,
          modelo_vehiculo: this.model_modelo_vehiculo,
          year_vehiculo: this.model_year_vehiculo,
          user_id: this.getUserID(),
          modulo_id: '167',
          current_cliente_id: this.getCliente(),
          LISTA_DETALLE: this.LISTAaltasservicioDETALLE,
        },
        'conecta_ordenes_sertec/crear'
      )
        .then((data: any) => {
          this.loadingService.hideLoading('crear_alta_servicio');
          this.btnCrear_disabled = false;
          if (Number(data.data.CODIGO_RESPUESTA) > 1) {
            this.$snotify.error(data.data.MENSAJE_RESPUESTA);
          } else {
            this.$snotify.success(data.data.MENSAJE_RESPUESTA);
          }
          this.closeModal();
          this.get_alta_servicioCAB();
        })
        .catch((error: any) => {
          return null;
        })
        .finally(() => {
          return null;
        });
    } //end if isValid
  }

  editar() {
    if (this.validar() == true) {
      this.loadingService.showLoading(undefined, 'editar_alta_servicio');
      return fetchOrdenSerTec(
        {
          altasernumero: this.model_altasernumero,
          cliente: this.model_cliente,
          flota: this.model_flota_cliente,
          vehiculo: this.model_vehiculos_cliente,
          coordinador: this.model_filtro_coordinador,
          fecha_instalacion: this.model_fecha_instalacion,
          tecnico: this.model_filtro_tecnico,
          marca_vehiculo: this.model_marca_vehiculo,
          modelo_vehiculo: this.model_modelo_vehiculo,
          year_vehiculo: this.model_year_vehiculo,
          orden_numero: this.model_altaserorden_numero,
          user_id: this.getUserID(),
          current_cliente_id: this.getCliente(),
          modulo_id: '167',
          LISTA_DETALLE: this.LISTAaltasservicioDETALLE,
          anulada: this.model_filtro_anulado,
        },
        'conecta_ordenes_sertec/editar'
      )
        .then((data: any) => {
          this.loadingService.hideLoading('editar_alta_servicio');
          if (Number(data.data.CODIGO_RESPUESTA) > 1) {
            this.$snotify.error(data.data.MENSAJE_RESPUESTA);
          } else {
            this.$snotify.success(data.data.MENSAJE_RESPUESTA);
          }
          this.closeModal();
          this.get_alta_servicioCAB();
        })
        .catch((error: any) => {
          return null;
        })
        .finally(() => {
          return null;
        });
    }
  }

  getValidationErrorClass(fieldName: string) {
    this.model_vehiculos_cliente = this.model_vehiculos_cliente.toUpperCase();
    const error = this.errors.first(fieldName);
    const isRegexError =
      error && error.includes('(AA0000)') && error.includes('(AAAA00)');

    this.naranja = Boolean(isRegexError);

    const elements = document.querySelectorAll(
      '#modal-mantenedor-container > div.cardnew > div > div > div > form > div > div > div > div:nth-child(1) > div > div > div.layout.wrap > div:nth-child(4)'
    );
    elements.forEach(element => {
      const messageElement = element.querySelector('.v-messages__message');
      if (messageElement) {
        if (isRegexError) {
          messageElement.classList.add('orange-error--text');
        } else {
          messageElement.classList.remove('orange-error--text');
        }
      }
    });
  }

  validar() {
    const caracteresEspeciales: RegExp = /[!@#$%^&*()+=[\]{};':"\\|,.<>/?\s]+/;

    var isValid = true;
    if (this.model_cliente == null) {
      this.$snotify.error('Cliente es mandatorio');
      isValid = false;
    }

    if (this.model_flota_cliente == null) {
      //this.$snotify.error('Flota es mandatorio');
      //isValid = false;
    }
    if (this.model_marca_vehiculo == null) {
      this.$snotify.error('Marca de Vehículo es mandatorio');
      isValid = false;
    }
    if (this.model_modelo_vehiculo == null) {
      this.$snotify.error('Modelo de Vehículo es mandatorio');
      isValid = false;
    }
    if (this.model_year_vehiculo == null) {
      this.$snotify.error('Año de Vehículo es mandatorio');
      isValid = false;
    }

    if (this.model_year_vehiculo.length !== 4) {
      this.$snotify.error('Año de Vehículo debe ser de cuatro dígitos');
      isValid = false;
    }
    if (this.model_vehiculos_cliente == null) {
      this.$snotify.error('Vehículo es mandatorio');
      isValid = false;
    }
    if (caracteresEspeciales.test(this.model_vehiculos_cliente)) {
      this.$snotify.error(
        'Por favor ingrese el campo Vehiculo en un formato sin cáracteres especiales ni tampoco vacio.',
        { timeout: 3000 }
      );
      this.loadingService.hideLoading();
      return;
    }
    if (this.model_filtro_coordinador == null) {
      this.$snotify.error('Coordinador es mandatorio');
      isValid = false;
    }
    if (this.model_fecha_instalacion == null) {
      this.$snotify.error('Fecha instalación es mandatoria');
      isValid = false;
    }
    if (this.model_filtro_tecnico == null) {
      this.$snotify.error('Técnico es mandatorio');
      isValid = false;
    }
    if (this.model_altaserorden_numero == null) {
      this.$snotify.error('Número de orden es mandatorio');
      isValid = false;
    }
    if (
      this.LISTAaltasservicioDETALLE == undefined ||
      this.LISTAaltasservicioDETALLE.length < 1
    ) {
      this.$snotify.error('Detalle de Alta de Servicio es mandatorio');
      isValid = false;
    }

    return isValid;
  }

  async getSeries() {
    try {
      this.loadingService.showLoading();
      const result = await fetchOrdenSerTec(
        { ...this.data },
        'conecta_ordenes_sertec/get_series'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, LISTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1 || MENSAJE_RESPUESTA) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      return [...LISTA];
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }
}
